import { NativeBiometric, BiometryType } from '@capgo/capacitor-native-biometric';

export const isBiometricsAvailable = async () => {
  try {
    const result = await NativeBiometric.isAvailable();
    console.log('📱 biometricAuth: isAvailable result:', result);
    return result.isAvailable;
  } catch (error) {
    console.error('📱 biometricAuth: isAvailable error:', error);
    return false;
  }
};

export const getBiometryType = async () => {
  try {
    const result = await NativeBiometric.isAvailable();
    return result.biometryType || null;
  } catch {
    return null;
  }
};

export const authenticateWithBiometrics = async (reason = 'Please authenticate to access RE-BUILD-ME-PRO') => {
  try {
    console.log('📱 biometricAuth: 1. Checking biometric capability...');
    const availability = await NativeBiometric.isAvailable({ useFallback: false }).catch(() => ({ isAvailable: false, biometryType: null }));
    const biometryType = availability?.biometryType || null;
    console.log('📱 biometricAuth: 2. Capability result:', availability);

    if (!availability?.isAvailable) {
      return { success: false, error: 'unavailable', fallbackToPasscode: true };
    }

    console.log('📱 biometricAuth: 3. Calling verifyIdentity (with device passcode fallback)...');
    const result = await NativeBiometric.verifyIdentity({
      reason,
      title: 'RE-BUILD-ME-PRO',
      subtitle: biometryType === BiometryType.FACE_ID ? 'Sign in with Face ID' : 'Sign in with Touch ID',
      description: 'This will unlock your private journal.',
      // Allow iOS to fall back to device passcode if biometric auth is unavailable or fails.
      useFallback: true,
      fallbackTitle: 'Use Phone Passcode',
    });
    console.log('📱 biometricAuth: 4. Biometric success', result);
    
    // If we get here, authentication was successful
    return { success: true };
    
  } catch (error) {
    console.error('📱 biometricAuth: 5. Biometric error:', error);
    
    // Check if user cancelled
    if (error.message && (error.message.includes('cancel') || error.message.includes('Cancel'))) {
      console.log('📱 biometricAuth: User cancelled');
      return { success: false, error: 'cancelled' };
    }
    
    const message = String(error?.message || '').toLowerCase();
    if (message.includes('not available') || message.includes('not enrolled') || message.includes('biometry')) {
      return { success: false, error: 'unavailable', fallbackToPasscode: true };
    }

    // Other errors
    return { success: false, error: error.message };
  }
};

export default {
  isBiometricsAvailable,
  getBiometryType,
  authenticateWithBiometrics,
};